import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/routes';
import { firstAllowedPath, isSidebarKeyAllowed } from '@/data/sidebarMenu';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Clave del catálogo de sidebar. Si el plan no la incluye, la ruta no abre. */
  menuKey?: string;
  superAdminOnly?: boolean;
}

export function ProtectedRoute({ children, menuKey, superAdminOnly }: ProtectedRouteProps) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (superAdminOnly && !user?.isSuperAdmin) {
    return <Navigate to={firstAllowedPath(user?.sidebarMenu)} replace />;
  }

  if (menuKey && !isSidebarKeyAllowed(user?.sidebarMenu, menuKey)) {
    const dest = firstAllowedPath(user?.sidebarMenu);
    if (dest === location.pathname) {
      return (
        <div className="flex min-h-screen items-center justify-center p-6 text-sm text-gray-600 dark:text-gray-300">
          Esta sección no está incluida en tu plan.
        </div>
      );
    }
    return <Navigate to={dest} replace />;
  }

  return <>{children}</>;
}
